const _white = "#FFFFFF"
const _transparent = "transparent"
const _black = "#000000"
const _light = "#FCFFFB"
const _modal = "#F6FCF6"
const _dark20 = "#434343"
const _ng900 = "#707070"
const _ng800 = "#2F3531"
const _ng700 = "#242F2A"
const _ng600 = "#47504A"
const _ng400 = "#5F6A62"
const _ng300 = "#6B776F"
const _ng200 = "#DFE5DB"
const _ng100 = "#E7F4EB"
const _ng80 = "#D3D6D2"
const _ng70 = "#ACB3AE"
const _ng60 = "#B9BFBB"
const _ng50 = "#C6CBC8"
const _ng40 = "#F1F6F1"
const _ng30 = "#EDEEED"
const _ng20 = "#EAF1EC"
const _ng10 = "#D2DACD"
const _n700 = "#3F3F3F"
const _n400 = "#656565"
const _n300 = "#717171"
const _n100 = "#D9D9D9"
const _footer = "#49554C"
const _pink = "#F6EEEB"
const _blue = "#EBF5F1"
const _green = "#F3F6E8"
const _grey = "#E4E1DB"
const config = { "white": _white, "transparent": _transparent, "black": _black, "light": _light, "modal": _modal, "dark20": _dark20, "ng900": _ng900, "ng800": _ng800, "ng700": _ng700, "ng600": _ng600, "ng400": _ng400, "ng300": _ng300, "ng200": _ng200, "ng100": _ng100, "ng80": _ng80, "ng70": _ng70, "ng60": _ng60, "ng50": _ng50, "ng40": _ng40, "ng30": _ng30, "ng20": _ng20, "ng10": _ng10, "n700": _n700, "n400": _n400, "n300": _n300, "n100": _n100, "footer": _footer, "pink": _pink, "blue": _blue, "green": _green, "grey": _grey, "link-color-green": "#445A40", "links-highlight": "#E3FCEF", "footer-hover-bg": "rgba(36, 47, 42, 0.3)", "footer-opacity": "rgba(217, 217, 217, 0.2)", "fruit-bg": "rgba(218, 212, 205, 0.7)", "fruit-bg-alt": "rgba(210, 218, 205, 0.7)", "pagination-active": "#F1F6F1",  }
export { config as default, _white, _transparent, _black, _light, _modal, _dark20, _ng900, _ng800, _ng700, _ng600, _ng400, _ng300, _ng200, _ng100, _ng80, _ng70, _ng60, _ng50, _ng40, _ng30, _ng20, _ng10, _n700, _n400, _n300, _n100, _footer, _pink, _blue, _green, _grey }